import { APIStatus } from '@application/common/enums/api-status';
import { createSlice } from '@reduxjs/toolkit';
import { applyVacancy, filterVacancies, getVacancies, getVacancyById } from './VacancyThunk';
const initialState = {
    status: APIStatus.IDLE,
    typeOfEmployement: [],
    areaOfExpertiseOptions: []
};
export const VacancyStateSlice = createSlice({
    name: 'Vacancy',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getVacancies.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getVacancies.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.vacancies = action.payload;
            state.typeOfEmployement = [...new Set(action.payload?.map((vacancy) => vacancy.employmentType))];
            state.areaOfExpertiseOptions = [...new Set(action.payload?.map((vacancy) => vacancy.fieldOfExpertise))];
        })
            .addCase(getVacancies.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getVacancyById.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getVacancyById.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.vacancy = action.payload;
        })
            .addCase(getVacancyById.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(applyVacancy.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(applyVacancy.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.vacancies = action.payload;
        })
            .addCase(applyVacancy.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(filterVacancies.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(filterVacancies.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.vacancies = action.payload;
        })
            .addCase(filterVacancies.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default VacancyStateSlice.reducer;
